<!-- -------- desktop header --------- -->
<div class="header desktop d-flex justify-content-center align-items-center" [ngClass]="{'scrolled': isScrolled}"
  *ngIf="windowSize > 1024">
  <div class="cursor-pointer" (click)="navigateToSection('home'); addActive($event)" #navigation>
    <svg-icon src="./assets/images/svg-icons/logo.svg" [svgStyle]="{ 'height.px':44 }"></svg-icon>
  </div>
  <div class="d-flex justify-content-center align-items-center flex-grow-1">
    <a href="{{currentLanguage}}/dashboard" title="Dashboard" translate>nav_dashboard</a>
    <a *ngFor="let item of navigations" href="javascript:void(0)"
      (click)="navigateToSection(item.routeName); addActive($event)" title="{{item.routeName}}"
      translate>{{item.navName}}</a>
    <div class="btn-group language mx-3" dropdown>
      <div dropdownToggle type="button" class="dropdown-toggle amountType d-flex align-items-center">
        <img class="flag-icon" src="./assets/images/flags/{{selectedLanguage?.flag}}.svg" alt="">
        <!-- <span class="ms-1">{{ selectedLanguage?.name }}</span> -->
        <svg-icon class="dropdown" src="./assets/images/svg-icons/download.svg"></svg-icon>
      </div>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
        <li class="p-2 cursor-pointer" role="menuitem" *ngFor="let lang of languagesList"
          (click)="changeLanguage(lang.value)">
          <img src="./assets/images/flags/{{lang.flag}}.svg" alt="">
          <span>{{ lang.name }}</span>
        </li>
      </ul>
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-end">
    <div class="social-icon d-flex align-items-center">
      <a href="https://smardex.io/swap?chainId=42161&tokenA=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&tokenB=0xe43b45c34e654b1038cecdb57a0302a788fea3f5"
      target="_blank" class="mx-2"> <img src="./assets/images/svg-icons/smardex-icon.svg" class="img-fluid" alt=""></a>
      <a href="https://www.dextools.io/app/en/ether/pair-explorer/0xcd09b73dfeb14233fde9a473878d28cdaf2aa4ed"
        target="_blank" class="mx-2"> <img src="./assets/images/svg-icons/dextools.svg" class="img-fluid" alt=""></a> <a
        href="https://twitter.com/XRP_20" target="_blank" class="mx-2"> <img
          src="./assets/images/svg-icons/social-icons/twitter-icon.svg" class="img-fluid" alt=""></a>
      <a href="https://t.me/XRP20_coin" target="_blank" class="mx-2"> <img
          src="./assets/images/svg-icons/social-icons/telegram-icon.svg" class="img-fluid" alt=""></a>
    </div>
    <a class="connect d-flex align-items-center ms-2" (click)="connectModal()" *ngIf="isStaking && !walletAddress"
      translate>
      connect_wallet</a>
    <!-- <a class="connect d-flex align-items-center ms-2" href="{{currentLanguage}}/dashboard" translate *ngIf="!isStaking">
      buy_now</a> -->
      <div class="btn-group buy-now  mx-3" dropdown>
        <div dropdownToggle type="button" class="connect dropdown-toggle amountType d-flex align-items-center">
          <span class="me-1" translate> buy_now</span>
          <svg-icon class="dropdown" src="./assets/images/svg-icons/download.svg"></svg-icon>
        </div>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right mt-2" role="menu">
          <li class="p-2 cursor-pointer" >
           <a class="text-black d-inline-block  font-14 py-0 text-start mx-1" href="https://smardex.io/swap?chainId=42161&tokenA=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&tokenB=0xe43b45c34e654b1038cecdb57a0302a788fea3f5" target="_blank" translate>buy_smardex</a>
          </li>
          <li class="p-2 cursor-pointer" >
           <a class="text-black d-inline-block  font-14 py-0 text-start mx-1" href="https://app.uniswap.org/swap" target="_blank" translate>buy_uniswap</a>
          </li>
        </ul>
        </div>
    <div class="connect d-flex align-items-center ms-2" (click)="disconnect()" *ngIf="walletAddress">
      <svg-icon src="./assets/images/svg-icons/connected-dot.svg"
        [svgStyle]="{ 'width.px':24, 'height.px':24 }"></svg-icon>
      <div class="ms-2">{{walletAddress | trimAddress}}</div>
    </div>
  </div>

</div>


<!-- -------- mobile header --------- -->

<div class="header mobile" [ngClass]="{'scrolled': isScrolled}" *ngIf="windowSize <= 1024">

  <div class="d-flex justify-content-between align-items-center">
    <div class="cursor-pointer" (click)="navigateToSection('home'); addActive($event)" #navigation>
      <svg-icon src="./assets/images/svg-icons/logo.svg" [svgStyle]="{ 'width.px':60, 'height.px': 25 }"></svg-icon>
    </div>
    <a class="connect d-flex align-items-center ms-2" (click)="connectModal()" *ngIf="isStaking && !walletAddress"
      translate>
      connect_wallet</a>
    <!-- <a class="connect d-flex align-items-center ms-2" href="{{currentLanguage}}/dashboard" translate *ngIf="!isStaking">
      buy_now</a> -->
      <div class="btn-group buy-now  mx-3" dropdown>
        <div dropdownToggle type="button" class="connect dropdown-toggle amountType d-flex align-items-center">
          <span class="me-1" translate> buy_now</span>
          <svg-icon class="dropdown" src="./assets/images/svg-icons/download.svg"></svg-icon>
        </div>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right mt-2" role="menu">
          <li class="p-2 cursor-pointer" >
           <a class="text-black d-inline-block font-14 py-0 text-start mx-1" href="https://smardex.io/swap?chainId=42161&tokenA=0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee&tokenB=0xe43b45c34e654b1038cecdb57a0302a788fea3f5" target="_blank" translate>buy_smardex</a>
          </li>
          <li class="p-2 cursor-pointer" >
           <a class="text-black d-inline-block font-14 py-0 text-start mx-1" href="https://app.uniswap.org/swap" target="_blank" translate>buy_uniswap</a>
          </li>
        </ul>
        </div>
    <div class="ms-2" (click)="openCloseMenu()">
      <svg-icon src="./assets/images/svg-icons/{{showMenu ? 'burger-close' : 'burger-icon'}}.svg"
        [svgStyle]="{ 'width.px':32, 'height.px':32 }"></svg-icon>
    </div>

    <!-- <div class="connect-wrapper d-flex">
    <div class=" d-flex align-items-center w-100 " (click)="disconnect()" *ngIf="walletAddress">
      <svg-icon src="./assets/images/svg-icons/connected-dot.svg" [svgStyle]="{ 'width.px':19, 'height.px':19 }">
      </svg-icon>
      <div class="btn btn-white fs-6 w-100 me-3">{{walletAddress | trimAddress}}</div>
    </div>

    <div class=" d-flex align-items-center " (click)="connectModal('banner')" *ngIf="!walletAddress">
      <div class="btn btn-white w-100 me-3" translate>buy_now</div>
    </div>
    <div class=" d-flex align-items-center " (click)="connectModal('banner')" *ngIf="!walletAddress">
      <div class="btn btn-white w-100 me-3" translate>buy_stake_now</div>
    </div>
  </div> -->
  </div>

  <div class="menu-overlay" *ngIf="showMenu">
    <div class="sub-menu d-flex flex-column justify-content-start align-items-center pull-left"
      [ngClass]="{'open': openMenu}">
      <a href="{{currentLanguage}}/dashboard" title="Dashboard" translate>nav_dashboard</a>

      <a *ngFor="let item of navigations" href="javascript:void(0)"
        (click)="navigateToSection(item.routeName); addActive($event); openCloseMenu()" title="{{item.routeName}}"
        translate>
        {{item.navName}}
      </a>

      <div class="connect d-flex align-items-center w-100 mb-3" (click)="connectModal(); openCloseMenu()"
        *ngIf="!walletAddress" translate>connect</div>
      <div class="connect d-flex align-items-center w-100 mb-3" (click)="disconnect(); openCloseMenu()"
        *ngIf="walletAddress">
        <svg-icon src="./assets/images/svg-icons/connected-dot.svg"
          [svgStyle]="{ 'width.px':20, 'height.px':24 }"></svg-icon>
        <div class="ms-1 fs-6">{{ walletAddress | trimAddress }}</div>
      </div>

      <div class="btn-group language" dropdown>
        <div dropdownToggle type="button" class="dropdown-toggle d-flex align-items-center">{{ selectedLanguage?.name }}
        </div>
        <ul *dropdownMenu class="dropdown-menu" role="menu">
          <li class="p-2 cursor-pointer" role="menuitem" *ngFor="let lang of languagesList"
            (click)="changeLanguage(lang.value); openCloseMenu()">{{ lang.name }}</li>
        </ul>
      </div>
    </div>

  </div>
</div>